// extracted by mini-css-extract-plugin
export default {"disclaimer":"l_bc"};